import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitomahabaleshwarcab() {



    const cardData = {

keyword: "Navi Mumbai to Mahabaleshwar Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai to Mahabaleshwar Cab services for family vacations, weekend getaways, honeymoon trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving, we ensure a smooth, comfortable, and hassle-free journey to Mahabaleshwar.",

topPlaces: [
    {
        title: "Venna Lake",
        description:
            "Venna Lake is one of the most popular attractions in Mahabaleshwar, offering boating, horse riding, and beautiful surroundings ideal for families and couples."
    },
    {
        title: "Arthur Seat Point",
        description:
            "Arthur Seat Point is a famous viewpoint known for breathtaking views of deep valleys, mountains, and the Savitri River gorge."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a well-known tourist destination famous for strawberry products, delicious food, and family-friendly attractions."
    },
    {
        title: "Elephant's Head Point",
        description:
            "Elephant's Head Point offers spectacular views of the Sahyadri hills and unique rock formations resembling an elephant's head."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest point in Mahabaleshwar and a popular location for witnessing stunning sunrise and panoramic mountain views."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is a scenic waterfall surrounded by lush greenery, especially attractive during the monsoon season."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is a historic Maratha fort associated with Chhatrapati Shivaji Maharaj and offers impressive views of the surrounding region."
    },
    {
        title: "Panchgani",
        description:
            "Panchgani is a nearby hill station known for Table Land, scenic valleys, boarding schools, and pleasant weather throughout the year."
    },
    {
        title: "Kate's Point",
        description:
            "Kate's Point is a popular viewpoint overlooking Dhom Dam and the surrounding valleys, making it a favorite photography location."
    },
    {
        title: "Strawberry Farms",
        description:
            "Mahabaleshwar is famous for its strawberry farms where visitors can enjoy fresh strawberries, farm tours, and local produce."
    }
],



services: [
{
name: "Mumbai to Mahabaleshwar Cab",
description: "Mumbai Airport Cab offers Mumbai to Mahabaleshwar Cab service for tourists, families, couples, corporate travellers, and groups looking for safe and comfortable transportation to the famous hill station of Mahabaleshwar. We provide Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles for one-way trips, round trips, sightseeing tours, and customized travel packages. Our professional chauffeurs ensure timely pickups, safe highway driving, luggage assistance, and a relaxing travel experience throughout the journey. With affordable fares, online booking support, transparent pricing, clean vehicles, and 24x7 customer assistance, we make every Mahabaleshwar trip convenient, enjoyable, and completely hassle-free."
},
{
name: "Mumbai to Mahabaleshwar Taxi Fare",
description: "Mumbai to Mahabaleshwar Taxi Fare with Mumbai Airport Cab is affordable, transparent, and suitable for different travel requirements and budgets. We offer competitive pricing for Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and premium vehicle categories without hidden charges. Whether you need a one-way transfer, round-trip journey, weekend getaway, family vacation, or sightseeing package, our fare plans provide excellent value. Passengers benefit from professional chauffeur service, comfortable vehicles, timely pickups, reliable customer support, and a smooth travel experience from Mumbai to Mahabaleshwar."
},
{
name: "Mumbai to Mahabaleshwar Taxi",
description: "Mumbai to Mahabaleshwar Taxi service provides reliable and comfortable transportation for holiday travellers, families, honeymoon couples, corporate guests, and sightseeing groups. Mumbai Airport Cab offers well-maintained vehicles equipped with modern comforts and driven by experienced chauffeurs. We focus on passenger safety, punctuality, and travel convenience while ensuring smooth highway journeys. With flexible travel schedules, affordable pricing, online reservations, and dedicated customer assistance, our taxi service helps passengers enjoy a stress-free and memorable journey to Mahabaleshwar."
},
{
name: "Car from Mumbai to Mahabaleshwar",
description: "Car from Mumbai to Mahabaleshwar service offers flexible travel solutions for passengers seeking private and comfortable transportation to the scenic hill station. Mumbai Airport Cab provides a wide range of vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, and luxury options for families, groups, and business travellers. Our professional drivers ensure safe travel, convenient pickups, and smooth journeys through the beautiful Western Ghats. With transparent pricing, easy booking options, and dependable service, we deliver a premium travel experience for every customer."
},
{
name: "Mumbai to Mahabaleshwar Cab Booking",
description: "Mumbai to Mahabaleshwar Cab Booking service allows travellers to reserve comfortable transportation quickly and conveniently. Mumbai Airport Cab offers instant booking confirmation, multiple vehicle choices, transparent fare structures, and round-the-clock customer support. Whether planning a family holiday, romantic getaway, business trip, or sightseeing tour, passengers can select the ideal vehicle according to their needs. Our focus on reliability, safety, punctuality, and customer satisfaction ensures a smooth booking process and an enjoyable travel experience."
},
{
name: "Mumbai to Mahabaleshwar Round Trip Cab",
description: "Mumbai to Mahabaleshwar Round Trip Cab service is ideal for travellers planning return journeys with maximum convenience and flexibility. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs, and customized travel schedules suitable for vacations, sightseeing tours, family trips, and corporate travel. We ensure safe transportation, timely service, and excellent customer support throughout the journey. With affordable packages, transparent pricing, and clean vehicles, our round-trip cab service offers a dependable and relaxing travel solution."
},
{
name: "Taxi for Mahabaleshwar from Mumbai",
description: "Taxi for Mahabaleshwar from Mumbai service offers dependable transportation for tourists visiting one of Maharashtra's most beautiful hill stations. Mumbai Airport Cab provides comfortable air-conditioned vehicles, professional drivers, and personalized travel solutions for individuals, families, and groups. We ensure smooth highway travel, punctual pickups, and reliable service from departure to arrival. With competitive pricing, flexible travel options, and dedicated customer support, passengers can enjoy a comfortable and memorable journey to Mahabaleshwar."
},
{
name: "Navi Mumbai to Mahabaleshwar Cab",
description: "Navi Mumbai to Mahabaleshwar Cab service provides safe, comfortable, and convenient transportation for travellers departing from Navi Mumbai. Mumbai Airport Cab offers Sedan, SUV, Innova, Innova Crysta, Ertiga, and Tempo Traveller options suitable for families, tourists, and corporate travellers. Our experienced chauffeurs ensure smooth highway driving, timely pickups, and a pleasant travel experience. With transparent pricing, online booking facilities, well-maintained vehicles, and 24x7 customer support, we make every trip to Mahabaleshwar comfortable and worry-free."
},
{
name: "Navi Mumbai to Mahabaleshwar Taxi",
description: "Navi Mumbai to Mahabaleshwar Taxi service delivers reliable intercity transportation for families, couples, tourists, and business travellers. Mumbai Airport Cab provides comfortable vehicles equipped for long-distance travel along with experienced chauffeurs dedicated to passenger safety and convenience. We focus on punctual service, smooth highway journeys, and customer satisfaction. Whether booking for a weekend getaway or an extended vacation, our taxi service ensures affordable fares, flexible schedules, and a comfortable travel experience."
},
{
name: "Navi Mumbai to Mahabaleshwar Cab Service",
description: "Navi Mumbai to Mahabaleshwar Cab Service offers professional transportation solutions designed for comfort, safety, and convenience. Mumbai Airport Cab provides clean vehicles, courteous chauffeurs, and dependable travel arrangements for holidaymakers, families, and corporate travellers. We ensure timely pickups, smooth road travel, and personalized service tailored to individual requirements. With easy booking options, transparent pricing, and dedicated customer assistance, passengers can enjoy a seamless and enjoyable journey to Mahabaleshwar."
},
{
name: "Taxi from Navi Mumbai to Mahabaleshwar",
description: "Taxi from Navi Mumbai to Mahabaleshwar service provides direct and comfortable transportation to the hill station for travellers seeking convenience and reliability. Mumbai Airport Cab offers a variety of vehicle options, professional chauffeurs, and safe travel arrangements suitable for every type of traveller. We focus on punctuality, customer satisfaction, and hassle-free transportation. With competitive pricing, comfortable seating, and dependable support, passengers can travel confidently and comfortably."
},
{
name: "Cab from Navi Mumbai to Mahabaleshwar",
description: "Cab from Navi Mumbai to Mahabaleshwar service offers efficient travel solutions for tourists, families, groups, and business professionals. Mumbai Airport Cab provides well-maintained vehicles, experienced drivers, and flexible travel plans to suit different requirements. Our service emphasizes passenger comfort, safety, and convenience while delivering reliable transportation across the route. With affordable rates, transparent fares, and excellent customer support, every journey is designed to be smooth and enjoyable."
},
{
name: "Book Cab Navi Mumbai to Mahabaleshwar",
description: "Book Cab Navi Mumbai to Mahabaleshwar service allows customers to arrange their travel quickly through a simple and convenient reservation process. Mumbai Airport Cab offers instant confirmations, multiple vehicle choices, transparent pricing, and dependable chauffeur services. Whether planning travel in advance or requiring immediate transportation, passengers receive professional support and reliable service. Our goal is to provide a comfortable and stress-free travel experience from booking to destination."
},
{
name: "Online Cab Booking Navi Mumbai to Mahabaleshwar",
description: "Online Cab Booking Navi Mumbai to Mahabaleshwar service provides a fast and convenient way to reserve transportation for hill station travel. Mumbai Airport Cab offers secure booking options, instant confirmations, flexible scheduling, and a wide fleet of vehicles to meet different travel needs. Our professional chauffeurs, comfortable vehicles, and responsive customer support ensure a smooth journey. We make online cab reservations simple, reliable, and convenient for every passenger."
},
{
name: "Best Cab Navi Mumbai to Mahabaleshwar",
description: "Best Cab Navi Mumbai to Mahabaleshwar service delivers a premium travel experience with comfortable vehicles, experienced chauffeurs, and outstanding customer service. Mumbai Airport Cab focuses on punctuality, passenger safety, and travel convenience while offering a range of vehicle options for families, tourists, and corporate travellers. We provide transparent pricing, clean vehicles, and professional support to ensure every journey meets the highest standards of comfort and reliability."
},
{
name: "Cheapest Cab Navi Mumbai to Mahabaleshwar",
description: "Cheapest Cab Navi Mumbai to Mahabaleshwar service provides budget-friendly transportation without compromising on quality, safety, or comfort. Mumbai Airport Cab offers affordable fares for Sedan, SUV, Innova, and other vehicle categories with transparent pricing and no hidden charges. Our professional drivers ensure smooth travel, timely service, and passenger convenience throughout the journey. Customers enjoy economical travel solutions backed by dependable support and well-maintained vehicles."
},
{
name: "Reliable Taxi Navi Mumbai to Mahabaleshwar",
description: "Reliable Taxi Navi Mumbai to Mahabaleshwar service ensures dependable transportation for travellers seeking comfort, punctuality, and safety. Mumbai Airport Cab provides experienced chauffeurs, clean vehicles, and customer-focused travel solutions suitable for families, tourists, and business travellers. We maintain high standards of service quality while ensuring smooth highway travel and timely arrivals. With transparent fares, flexible booking options, and dedicated customer assistance, we deliver a trusted and enjoyable travel experience."
}
],

tableData: [
["Mumbai to Mahabaleshwar Cab","Mumbai to Mahabaleshwar Taxi Fare"],
["Mumbai to Mahabaleshwar Taxi","Car from Mumbai to Mahabaleshwar"],
["Mumbai to Mahabaleshwar Cab Booking","Mumbai to Mahabaleshwar Round Trip Cab"],
["Taxi for Mahabaleshwar from Mumbai","Navi Mumbai to Mahabaleshwar Cab"],
["Navi Mumbai to Mahabaleshwar Taxi","Navi Mumbai to Mahabaleshwar Cab Service"],
["Taxi from Navi Mumbai to Mahabaleshwar","Cab from Navi Mumbai to Mahabaleshwar"],
["Book Cab Navi Mumbai to Mahabaleshwar","Online Cab Booking Navi Mumbai to Mahabaleshwar"],
["Best Cab Navi Mumbai to Mahabaleshwar","Cheapest Cab Navi Mumbai to Mahabaleshwar"],
["Reliable Taxi Navi Mumbai to Mahabaleshwar","Mumbai to Mahabaleshwar Cab"]
],









whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai to Mahabaleshwar Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai to Mahabaleshwar Cab services for families, couples, tourists, corporate travelers, and weekend vacationers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Perfect Hill Station Getaway",
        WhyChoosedescription: "Mahabaleshwar is one of Maharashtra's most popular hill stations known for its scenic viewpoints, pleasant weather, strawberry farms, waterfalls, and natural beauty."
    },
    {
        WhyChooseheading: "Comfortable and Scenic Road Journey",
        WhyChoosedescription: "Enjoy a relaxing drive through beautiful highways, mountain roads, lush greenery, and breathtaking landscapes while traveling from Navi Mumbai to Mahabaleshwar."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, same-day return, weekend package, family vacation trip, or customized sightseeing tour, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Hill Station Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced in ghat roads and hill station routes, ensuring safe, comfortable, and stress-free travel."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Groups",
        WhyChoosedescription: "From romantic vacations and family holidays to corporate outings and group tours, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai to Mahabaleshwar Cabs?",
        answer: "Mahabaleshwar is famous for its cool climate, scenic viewpoints, strawberry farms, boating spots, waterfalls, and peaceful hill station atmosphere."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai to Mahabaleshwar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized holiday travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai to Mahabaleshwar travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide weekend getaway packages?",
        answer: "Yes, customers can book weekend trips, family vacation packages, honeymoon tours, and customized Mahabaleshwar sightseeing plans."
    },
    {
        question: "Can families travel comfortably to Mahabaleshwar?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for families, senior citizens, children, and long-distance travelers."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, school trips, and tourist groups."
    },
    {
        question: "Can sightseeing places be included during the trip?",
        answer: "Yes, customers can visit Arthur Seat Point, Elephant Head Point, Venna Lake, Mapro Garden, Wilson Point, Lingmala Waterfall, and other attractions."
    },
    {
        question: "Can pickup be arranged from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Is advance booking recommended for Mahabaleshwar travel?",
        answer: "Yes, advance booking is recommended, especially during weekends, holidays, summer vacations, and monsoon seasons."
    },
    {
        question: "How can I book a Navi Mumbai to Mahabaleshwar Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sagar Bhosale",
        feedback:
            "Our Mahabaleshwar holiday was fantastic. The cab was comfortable, the driver was courteous, and the scenic journey made the trip even more memorable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rupal Vora",
        feedback:
            "We booked a family trip from Navi Mumbai to Mahabaleshwar and received excellent service. The vehicle was clean, spacious, and perfectly suited for our vacation.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai to Mahabaleshwar Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-to-mahabaleshwar-cab.jpg",
"description": "Book Navi Mumbai to Mahabaleshwar cab service for hill station travel, family trips, and weekend getaways. Mumbai Airport Cabs offers safe and comfortable outstation taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-to-mahabaleshwar-cab"
}
};







    return (
        <div>


<Helmet>
  <title>Navi Mumbai to Mahabaleshwar Cab | Hill Station Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai to Mahabaleshwar cab for hill station trips, family vacations, and weekend travel. Safe and comfortable taxi service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai to mahabaleshwar cab, mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi, mumbai to mahabaleshwar taxi fare, mumbai to mahabaleshwar cab booking, mumbai to mahabaleshwar round trip cab, taxi from navi mumbai to mahabaleshwar, navi mumbai to mahabaleshwar cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitomahabaleshwarcab;